export default __webpack_public_path__ + "static/media/pergaminho.28805067.png";